import view from 'bundle-text:../dom/landing.html';
import app from './app';

export default () => {
  const content = document.createElement('div');

  content.classList.add(
    'align-items-center',
    'd-flex',
    'justify-content-center',
    'w-100',
  );
  content.innerHTML = view;

  document.title = `${app.run.settings.view.landing.pageTitle}${app.run.settings.siteTitleSeparator}${app.run.settings.siteTitle}`;

  content.querySelector(`#app-i18n-${app.run.i18n}`).classList.add('active');

  return content;
};
